/**
 * Parse JSON from a fetch Response without throwing misleading SyntaxErrors on empty bodies.
 * Empty/truncated responses often come from timeouts, 502/524, or edge failures without a JSON body.
 */
export async function parseResponseJson<T = unknown>(res: Response): Promise<T> {
  const text = await res.text()
  const trimmed = text.trim()
  if (!trimmed) {
    throw new Error(
      res.ok
        ? 'Empty response from server. Try again or check logs (timeout or upstream error).'
        : `Server returned ${res.status} with an empty body.`
    )
  }
  try {
    return JSON.parse(trimmed) as T
  } catch {
    const preview = trimmed.length > 120 ? `${trimmed.slice(0, 120)}…` : trimmed
    throw new Error(
      res.ok
        ? `Server returned non-JSON: ${preview}`
        : `Request failed (${res.status}). Response was not valid JSON.`
    )
  }
}
